/**
 * æ¯è¾ç¬¦
 */
export enum CompareType{
    Equal = 0,
    NotEqual = 1,
    Greater = 2,
    GreaterOrEqual = 3,
    Less = 4,
    LessOrEqual = 5,
    Like = 6,
    LikeStartWith = 7,
    LikeEndWith = 8,
    NotLike = 9,
    NotLikeStartWith = 10,
    NotLikeEndWith = 11,
    Is = 12,
    IsNot = 13,
    In = 14,
    NotIn = 15
}